import React, { MouseEventHandler } from "react";
import moment from 'moment';
import styled, { ThemedCssFunction } from "styled-components";
import Button from "../Button";
import { getDateFilterDisplayString } from '../../utils/showtimes';
import { ucFirst } from '../../utils/strings';

const Scroller = styled.div<{customStyle?: ThemedCssFunction<string>}>`
  overflow-x: auto;
  padding: 0.5rem 0 0.25rem 0;
  white-space: nowrap;

  &::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }

  &::-webkit-scrollbar-track { background: #fcfcfc; /* Color of the track */ }
  &::-webkit-scrollbar-thumb { background: #eee; /* Color of the thumb */ }
  &::-webkit-scrollbar-thumb:hover { background: #ddd; /* Darker color on hover */ }

  ${props => `${props.customStyle}` || ''}
`;

const StyledButton = styled(Button)<{customStyle?: ThemedCssFunction<string>, primary: boolean}>`
  margin-right: 0.5em;
  min-width: 90px;
  text-transform: uppercase;

  &:last-child { margin-right: var(--pad-x); }
  
  ${props => !props.primary && `${props.customStyle}` || ''}
`;

interface Props {
    items: Array<{ id: number, name: string }>,
    selectedItemId?: number | string,
    onSelect: (id: number) => void,
    customStyle?: ThemedCssFunction<string>,
    buttonCustomStyle?: ThemedCssFunction<string>,
}

function HorizontalScroller({items, selectedItemId, onSelect, customStyle, buttonCustomStyle}: Props) {
    return <Scroller customStyle={customStyle}>
        {items.map(item => (
            <StyledButton
                key={item.id}
                primary={item.id === selectedItemId}
                small
                onClick={() => onSelect(item.id)}
                customStyle={buttonCustomStyle}
            >
                {item.name}
            </StyledButton>
        ))}
    </Scroller>;
}

HorizontalScroller.StyledButton = StyledButton;
export default HorizontalScroller;